var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { OTPInput } from 'input-otp';
import classNames from 'classnames';
import { Decorator } from '../decorator';
function Slot(_a) {
    var isActive = _a.isActive, placeholderChar = _a.placeholderChar, char = _a.char, hasFakeCaret = _a.hasFakeCaret;
    return (React.createElement("div", { className: classNames('relative rounded-lg border-gray-300 leading-tight p-0 font-semibold border group-has-[:disabled]:bg-gray-50 group-has-[:disabled]:text-gray-500 text-gray-600 transition-colors group-focus-within:text-primary-600 group-focus-within:border-primary-600 group-focus-within:border-2 p-px group-focus-within:p-0 group-[.invalid]:text-error-600 group-[.invalid]:p-0 group-[.invalid]:border-error-600 group-[.invalid]:border-2', { 'ring-primary-100 ring-4': isActive }) },
        React.createElement("div", { className: 'size-[1lh] text-center' },
            char
                ? React.createElement("span", { className: classNames({ '': isActive }) }, char)
                : placeholderChar && React.createElement("span", { className: 'text-gray-300' }, placeholderChar),
            hasFakeCaret && React.createElement(FakeCaret, null))));
}
function FakeCaret() {
    return (React.createElement("div", { className: "absolute pointer-events-none inset-0 flex items-center justify-center animate-caret-blink" },
        React.createElement("div", { className: "w-px h-8 bg-black" })));
}
function render(_a) {
    var slots = _a.slots;
    return React.createElement("div", { className: classNames('flex flex-row gap-1 sm:gap-2 justify-between sm:justify-normal items-center') },
        slots.slice(0, 3).map(function (slot, idx) { return (React.createElement(Slot, __assign({ key: idx }, slot))); }),
        React.createElement("div", { className: "text-gray-300" }, "-"),
        slots.slice(3).map(function (slot, idx) { return (React.createElement(Slot, __assign({ key: idx }, slot))); }));
}
export var CodeInput = React.forwardRef(function (_a, ref) {
    var hint = _a.hint, label = _a.label, error = _a.error, errorMessage = _a.errorMessage, id = _a.id, fieldError = _a.fieldError, requiredIndicator = _a.requiredIndicator, className = _a.className, props = __rest(_a, ["hint", "label", "error", "errorMessage", "id", "fieldError", "requiredIndicator", "className"]);
    return React.createElement(Decorator, { id: id, className: className, error: error, errorMessage: errorMessage, label: label, hint: hint, fieldError: fieldError, requiredIndicator: requiredIndicator },
        React.createElement(OTPInput, __assign({ containerClassName: classNames('group', { 'invalid': fieldError || error }), render: render, id: id, ref: ref }, props)));
});
